/**
 * Choose a stamp, and the line under it, for the point the user clicked.
 */

import { useState } from 'react'
import type { StampKind } from '../api'

interface Props {
  author: string
  onPlace: (stamp: StampKind, detail: string) => void
  onCancel: () => void
}

const STAMPS: { id: StampKind; label: string; tone: 'go' | 'stop' | 'info' }[] = [
  { id: 'approved', label: 'APPROVED', tone: 'go' },
  { id: 'received', label: 'RECEIVED', tone: 'info' },
  { id: 'reviewed', label: 'REVIEWED', tone: 'info' },
  { id: 'final', label: 'FINAL', tone: 'go' },
  { id: 'for-comment', label: 'FOR COMMENT', tone: 'info' },
  { id: 'draft', label: 'DRAFT', tone: 'stop' },
  { id: 'confidential', label: 'CONFIDENTIAL', tone: 'stop' },
  { id: 'not-approved', label: 'NOT APPROVED', tone: 'stop' },
  { id: 'void', label: 'VOID', tone: 'stop' },
]

export function StampDialog({ author, onPlace, onCancel }: Props) {
  const today = new Date().toISOString().slice(0, 10)
  const [stamp, setStamp] = useState<StampKind>('approved')
  const [detail, setDetail] = useState(author ? `${today} · ${author}` : today)

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="stamp-title">
      <form className="modal__panel" onSubmit={(e) => { e.preventDefault(); onPlace(stamp, detail) }}>
        <h2 className="modal__title" id="stamp-title">Stamp</h2>
        <div className="modal__body">
          <div className="stamp-grid" role="radiogroup" aria-label="Stamp">
            {STAMPS.map((s) => (
              <button key={s.id} type="button" role="radio" aria-checked={stamp === s.id}
                      className="stamp-choice" data-tone={s.tone} onClick={() => setStamp(s.id)}>
                {s.label}
              </button>
            ))}
          </div>
          <label className="field">
            <span>Second line</span>
            <input value={detail} onChange={(e) => setDetail(e.target.value)} placeholder="optional" />
          </label>
          <p className="modal__hint">
            Placed where you clicked, as a standard PDF stamp: it can be moved or
            deleted later, here or in Acrobat.
          </p>
        </div>
        <div className="modal__footer">
          <button type="button" className="btn" onClick={onCancel}>Cancel</button>
          <button type="submit" className="btn btn--primary">Place stamp</button>
        </div>
      </form>
    </div>
  )
}
